import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';

export const TextFields = styled(TextField)`
    ${p => p.custom}
`
